var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "no-padding bg-white no-scroll full-height" },
    [
      _c(
        "q-card-main",
        { staticClass: "row full-height no-padding" },
        [
          _c(
            "div",
            {
              staticClass:
                "col-12 dash-number-box dash-number-box-padding relative-position"
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("q-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showAverage,
                        expression: "showAverage"
                      }
                    ],
                    staticClass: "q-mr-sm",
                    attrs: {
                      placeholder: _vm.$t("year"),
                      options: _vm.averageYearOptions,
                      "no-parent-field": "",
                      "hide-underline": ""
                    },
                    model: {
                      value: _vm.averageYear,
                      callback: function($$v) {
                        _vm.averageYear = $$v
                      },
                      expression: "averageYear"
                    }
                  }),
                  _c(
                    "q-toggle",
                    {
                      model: {
                        value: _vm.showAverage,
                        callback: function($$v) {
                          _vm.showAverage = $$v
                        },
                        expression: "showAverage"
                      }
                    },
                    [
                      _c("q-tooltip", { attrs: { offset: [0, 5] } }, [
                        _vm._v(
                          _vm._s(
                            _vm.showAverage
                              ? _vm.$t("hide_yearly_average")
                              : _vm.$t("show_yearly_average")
                          )
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("h2", { staticClass: "dash-number-box__heading--bold" }, [
                _vm._v(_vm._s(_vm.$t("statistics_revenue")))
              ]),
              _c("h3", { staticClass: "dash-number-box__sub-heading" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("statistics_activity_from_to", {
                        date1: _vm.revenueFrom,
                        date2: _vm.revenueTo
                      })
                    ) +
                    "\n      "
                )
              ]),
              _c(
                "div",
                { staticClass: "row items-start" },
                [
                  _c(
                    "span",
                    { staticClass: "dash-number-box__value on-left" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.formatMoney(_vm.lastRevenue, _vm.currency, 0, 0)
                        )
                      )
                    ]
                  ),
                  _vm.showTrend
                    ? _c("trend-hint", {
                        staticClass: "dash-number-box__value--trend",
                        attrs: { up: !_vm.revenueIsDown, text: _vm.trendText }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c("span", {
                staticClass: "dash-number-box__value--sub",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("statistics_revenue_month"))
                }
              })
            ]
          ),
          _c(_vm.chartComponent, {
            tag: "component",
            staticClass: "col-12 self-end",
            attrs: {
              chartdata: _vm.chartdata,
              options: _vm.chartoptions,
              height: 100
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }